
import { MongoView } from "@/models/mongo-view";
import { IAvailableMongoViewColumn } from "@/utils/mongo-view/mongo-view-column";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppColumnsEdit from "./ColumnsEdit.vue";
import { MongoViewService } from "@/services/mongo-view-service";
import { isStringNullOrWhitespace } from "@/utils/strings";

export default Vue.extend({
	data(){
		return {
			isSaving: false
		};
	},
	props: {
		view: {
			type: Object as ()=>MongoView,
			required: true
		},
		availableColumns: {
			type: Array as ()=>IAvailableMongoViewColumn[],
			required: true
		}
	},
	computed: {
		title():TranslateResult {
			if (this.view.ID == 0) {
				return this.$ct("new-view");
			}
			return this.$ct("edit-view");
		},
		valid():boolean {
			return this.view.Columns.length > 0 && !isStringNullOrWhitespace(this.view.Name);
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (this.isSaving) return;
			try{
				this.isSaving = true;
				if (this.view.ID) {
					await MongoViewService.updateView(this.view);
				}else{
					await MongoViewService.createView(this.view);
				}
				this.close();
			}catch(err){

			}finally{
				this.isSaving = false;
			}
		}
	},
	components: {
		AppColumnsEdit
	},
	i18nEx: {
		componentPrefix: "components.mongo-view-editor"
	}
});
